import Vue from 'vue'
import Review from '../models/Shop/Review'

export const state = () => ({
  featured_reviews: []
})

// getters
export const getters = {
  featuredReviews: (state) => {
    return state.featured_reviews
  }
}

// mutations
export const mutations = {
  setFeaturedReviews (state, reviews) {
    state.featured_reviews = reviews
  }
}

// actions
export const actions = {
  async fetchFeaturedReviews ({ commit }) {
    try {
      const reviews = await Review.where('featured', true).include('user', 'product', 'product.category').get()
      commit('setFeaturedReviews', reviews.data)
      return reviews.data
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  }
}
